module.exports = __webpack_public_path__ + "static/img/btn4.f864a5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/background/btn4.png
// module id = +3Kg
// module chunks = 1